<div class="bg-white w-full h-full">
  <!--  DESKTOP LAYOUT-->
  <div class="hidden md:flex justify-center">
    <div class="flex flex-col justify-center max-w-[304px]">
      <div class="dls-subhead-1-bold mb-1">
        {{ 'activity_error' | translate }}
      </div>
      <div class="dls-body-1-regular">
        {{ 'activity_error_description' | translate }}
      </div>
      <div class="mt-6">
        <zelis-button (clickFn)="handleRedirect()" [fullWidth]="false">
          {{ config.cta | translate }}
        </zelis-button>
      </div>
    </div>
    <div
      class="flex flex-col justify-center"
      [class.hidden]="suppressIllustrations | async"
    >
      <img src="/assets/images/activity-error.svg" aria-hidden="true" alt="" />
    </div>
  </div>

  <!--  MOBILE LAYOUT-->
  <div class="flex flex-col justify-center md:hidden">
    <div class="flex flex-col justify-center px-[5%] my-8">
      <div class="dls-subhead-1-bold">{{ 'activity_error' | translate }}</div>
      <div
        class="flex justify-center"
        [class.hidden]="suppressIllustrations | async"
      >
        <img
          src="/assets/images/activity-error.svg"
          aria-hidden="true"
          alt=""
        />
      </div>
      <div class="dls-body-1-regular">
        {{ 'activity_error_description' | translate }}
      </div>
      <div class="w-full mt-6">
        <zelis-button (clickFn)="handleRedirect()" [fullWidth]="true">
          {{ config.cta | translate }}
        </zelis-button>
      </div>
    </div>
  </div>
</div>
